<h1 class="Title-lg">
  Inventory Campaign Details (Internal)-{{componentName}} - {{selectedValue}}
</h1>
<br />
<div class="card">
  <ds-box
    [detachFooter]="true"
    class="dynamic-box"
    style="display: block; width: 100%; max-width: 100%"
  >
    <ds-box-content>
      <form [ds-form]="defectCodeForm" [formGroup]="defectCodeForm">
        <div
          class="action-bar"
          style="display: flex; align-items: center; gap: 2rem"
        >
          <div
            class="left-group"
            style="display: flex; align-items: center; gap: 1rem"
          >
            <ds-form-field class="mb-0 ms-2">
              <label ds-label for="defectCode">Enter Defect Code</label>
              <input
                ds-input
                ds-form-validation
                class="w-100"
                id="defectCode"
                type="text"
                placeholder="Insert Defect Code"
                formControlName="defectCode"
                maxlength="10"
              />
              <ds-error
                *ngIf="defectCodeForm.controls['defectCode'].hasError('pattern')"
                >Invalid Defect Code</ds-error
              >
              <br />
            </ds-form-field>
            <button
              ds-button
              ds-button-primary
              ds-loading
              [isLoading]="isDefectCodeLoading"
              loadingVariant="indeterminate"
              icon="search"
              type="submit"
              (click)="onSearch()"
            >
              Search
            </button>
            <ds-link
              href="#"
              label="Clear Search"
              (click)="onClearSelection(); $event.preventDefault();"
            ></ds-link>
          </div>
          <div
            class="actions-right"
            style="
              margin-left: auto;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            "
            *ngIf="path==='CampaignInventoryInternalNational' || path==='CampaignInventoryInternal'"
          >
            <h3 class="mb-0" style="font-weight: 500">
              Details as of : {{ currentDate }} at {{ currentTime }}
            </h3>
            <ds-button
              ds-button-secondary
              icon="refresh"
              class="refresh-btn"
              (click)="onRefresh()"
              >Refresh</ds-button
            >
          </div>
        </div>
        <ds-skeleton
          variant="text"
          textStyle="title-lg"
          [hasShimmer]="isDefectCodeLoading"
        >
        </ds-skeleton>
      </form>
    </ds-box-content>
  </ds-box>
  <ds-box>
    <div
      class="actions-right"
      *ngIf="defectCodeForm.valid && !isDefectCodeLoading && defectCodeForm.controls['defectCode'].value?.length > 1"
      style="
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: o.5rem;
        margin-right: 1rem;
      "
    >
      <p>
        Current Defect Code: {{ defectCodeForm.controls['defectCode'].value }}
      </p>
    </div>
  </ds-box>
  <br />
</div>
